import { render, staticRenderFns } from "./CreateTag.vue?vue&type=template&id=11527c8e&scoped=true"
import script from "./CreateTag.vue?vue&type=script&lang=js"
export * from "./CreateTag.vue?vue&type=script&lang=js"
import style0 from "./CreateTag.vue?vue&type=style&index=0&id=11527c8e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11527c8e",
  null
  
)

export default component.exports